
import { RevIllustration } from '@ds/components/Illustration'
import { openModal } from '@ds/components/ModalBase'
import { IconBadge } from '@ds/icons/IconBadge'
import { IconCalendar } from '@ds/icons/IconCalendar'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'

import VerifiedRefurbishedModal from '../VerifiedRefurbishedModal'

import translations from './ReassuranceButtons.translations'

export default {
  components: {
    IconBadge,
    IconCalendar,
    VerifiedRefurbishedModal,
    RevIllustration,
  },
  computed: {
    ...mapGetters({
      coolingOffDays: 'config/coolingOffDays',
      country: 'config/country',
    }),
    translations: () => translations,

    shouldDisplayVerifiedRefurbishedCampaign() {
      return (
        this.$config.FF_PRODUCT_VERIFIED_REFURBISHED_CAMPAIGN ?? ''
      ).includes(this.country)
    },
  },
  methods: {
    deploySatisfactionModal() {
      openModal(MODAL_NAMES.REASSURANCE.SATISFACTION)
    },
    deployVerifiedRefurbishedModal() {
      openModal(MODAL_NAMES.PRODUCT.VERIFIED_REFURBISHED)
    },
  },
}
